import { ApolloLink } from "@apollo/client";

/**
 * JWT cookie auth — used by admin in JWT mode.
 *
 * The browser sends the JWT cookie automatically when `credentials: include`
 * is set on the HTTP link (configured at the client level). This link is a
 * no-op pass-through; it exists so the factory has a uniform "auth link" slot
 * regardless of auth mode.
 *
 * 401s from the API are handled by the error link, not here.
 */
export const authJwtLink = new ApolloLink((operation, forward) => forward(operation));
